import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { AudioManager } from "./AudioManager";
import { Game } from "./Game";

export class Boot extends Phaser.State {

    public static currentInstance: Boot;

    private static bootedInWrongOrientation: boolean;

    public static onYandexFullscreenChanged() {

        const aspectRatio = GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH;

        if (Game.currentInstance.device.desktop) {

            let widthLimit = Math.min(screen.height / aspectRatio, window.innerHeight / aspectRatio);
            const heightLimit = Math.min(screen.height, window.innerHeight);

            Game.currentInstance.scale.minWidth = widthLimit;
            Game.currentInstance.scale.minHeight = heightLimit;

            Game.currentInstance.scale.maxWidth = widthLimit;
            Game.currentInstance.scale.maxHeight = heightLimit;

        } else {

            Game.currentInstance.scale.maxWidth = window.innerWidth;
            Game.currentInstance.scale.maxHeight = Math.max(screen.height, window.innerHeight);
        }

        GameVars.scaleY = aspectRatio / (Game.currentInstance.scale.maxHeight / Game.currentInstance.scale.maxWidth);

        Game.currentInstance.scale.refresh();
    }

    public static enterIncorrectOrientation(): void {

        document.getElementById("orientation").style.display = "block";
        document.getElementById("content").style.display = "none";
    }

    public static leaveIncorrectOrientation(): void {

        document.getElementById("orientation").style.display = "none";
        document.getElementById("content").style.display = "block";

        if (Boot.bootedInWrongOrientation) {

            Boot.bootedInWrongOrientation = false;

            Boot.currentInstance.game.time.events.add(250, function(): void {

                GameVars.scaleY = (4 / 3) / (window.innerHeight / window.innerWidth);

                Boot.currentInstance.game.scale.refresh();
                PokiSDK.init().then(
                    () => {
                        console.log("Poki SDK successfully initialized");
                        // your code to continue to game
                        Boot.currentInstance.game.state.start("PreLoader", true, false);
                    }   
                ).catch(
                    () => {
                        console.log("Initialized, but the user likely has adblock");
                        // your code to continue to game
                        Boot.currentInstance.game.state.start("PreLoader", true, false);
                    }   
                );
              
                
            }, Boot.currentInstance);
        }
    }

    public init(): void {

        Boot.currentInstance = this;

        this.input.maxPointers = 1;

        this.game.stage.disableVisibilityChange = true;

        // por el problema del stock browser
        this.game.stage.backgroundColor =  "#000000";

        this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;

        this.game.scale.pageAlignHorizontally = true;

        if (this.game.device.desktop) {

            GameVars.scaleY = 1;

            this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
            this.game.scale.pageAlignHorizontally = true;

        } else {

            this.game.scale.scaleMode = Phaser.ScaleManager.EXACT_FIT;

            GameVars.scaleY = (4 / 3) / (window.innerHeight / window.innerWidth);

            this.game.scale.pageAlignHorizontally = true;

            Boot.bootedInWrongOrientation = window.innerHeight < window.innerWidth;

            this.game.scale.forceOrientation(false, true);
            this.game.scale.enterIncorrectOrientation.add(Boot.enterIncorrectOrientation, Boot);
            this.game.scale.leaveIncorrectOrientation.add(Boot.leaveIncorrectOrientation, Boot);
        }

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_YANDEX) {
            window.onresize = Boot.onYandexFullscreenChanged;
            Boot.onYandexFullscreenChanged();
        }
        
        this.game.onBlur.add(function(): void {
            Game.currentInstance.sound.mute = true;
        }, this);

        this.game.onFocus.add(function(): void {
            
            if (!AudioManager.isMuted) {

                if (GameConstants.SPONSOR !== GameConstants.SPONSOR_POKI || !GameVars.onAd) {
                    Game.currentInstance.sound.mute = false;
                }
                
            }
        }, this);

        if (GameConstants.DEVELOPMENT) {
            // para poder medir las fps
            this.game.time.advancedTiming = true;
        }
    }

    public preload(): void {

        this.load.crossOrigin = "anonymous";

        this.load.image("background_splash", "assets/chess_splash_bg.jpg");
    }

    public create(): void {

        if (!Boot.bootedInWrongOrientation) {
            PokiSDK.init().then(
                () => {
                    console.log("Poki SDK successfully initialized");
                    // your code to continue to game
                    Boot.currentInstance.game.state.start("PreLoader", true, false);
                }   
            ).catch(
                () => {
                    console.log("Initialized, but the user likely has adblock");
                    // your code to continue to game
                    Boot.currentInstance.game.state.start("PreLoader", true, false);
                }   
            );
        }
    }

    public shutdown(): void {

        Boot.currentInstance = null;

        super.shutdown();
    }
}

